import React from 'react';
import './IntroSection.css';

const IntroSection = (props) => {
  const logos = [
    '/logos/image.png',
    '/logos/logo2.png',
    '/logos/logo4.png',
    '/logos/logo5.png',
    '/logos/logo6.png',
    '/logos/logo7.jpg',
    '/logos/logo8.png',
  ];

  return (
    <section
      className="services-intro"
      style={{
        backgroundImage: `url(${props.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      <div className="container">
        <div className="services-content">
          <div className="intro-left">
            <h1>{props.title}</h1>
            <p>{props.paragraph}</p>
          </div>
        </div>

        <div className="logo-strip">
          <span className="trusted-by">Trusted by</span>
          <div className="logo-track">
            <div className="logo-track-inner">
              {logos.concat(logos).map((logo, index) => (
                <img key={index} src={logo} alt="Company Logo" />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default IntroSection;